import type { CookieDefinition, CookieOptions } from "./cookies";
import { serializeCookie } from "./serializeCookie";

export function serializeExpiredCookie(
  cookie: CookieDefinition,
  overrides: Partial<CookieOptions> = {},
): string {
  return serializeCookie(cookie, "", { ...overrides, maxAge: 0 });
}
